import { withIfUser } from '@app/components/common/Routes';
import { hasPermissions } from '@app/utils';
import MatrixReport from '@app/views/Ledger/MatrixReport';
import { memo } from 'react';

export default memo(
  withIfUser(MatrixReport)({
    condition: ({ roles }) => roles.some(hasPermissions),
    redirect: true,
    redirectTo: '/unauthorized',
  })
);
